import { Col, Container, Row } from 'react-bootstrap';
import ProgressBar from '../ProgressBar';
import PaymentInformation from './PaymentInformation';
import styles from '../../styles/PaymentProcessContainer.module.scss';

export default function PaymentLayout({ children, hidePaymentInfo, isHostedPage }) {
  return (
    <Container fluid="xxl">
      <Row className="noPrint">
        {isHostedPage || <ProgressBar />}
      </Row>
      <Row className={`${styles.paymentProcessContainer} ${isHostedPage ? styles.noMarginTop : 'mb-5'}`}>
        {(!isHostedPage && !hidePaymentInfo) ?
          (
            <>
              <Col lg={8} xs={12} className={styles.contentContainer}>
                {children}
              </Col>
              <Col lg={4} xs={12} className={`${styles.contentContainer} noPrint`}>
                <PaymentInformation className={styles.paymentInfoContainer} />
              </Col>
            </>
          ) :
          (
            <Col lg={10} xs={12} className={styles.contentContainer}>
              {children}
            </Col>
          )}
      </Row>
    </Container>
  );
}
